import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./tokenlyglobal.css";

const CompactTracking = () => {
  const navigate = useNavigate();
  const [tokenData, setTokenData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTokenIndex, setActiveTokenIndex] = useState(0);
  const [allTokens, setAllTokens] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  const getAuthToken = () => localStorage.getItem("tokenly_token") || "";

  const fetchTokenTracking = useCallback(async () => {
    try {
      const authToken = getAuthToken();
      if (!authToken) {
        setIsVisible(false);
        return;
      }

      const response = await fetch("https://tokenly.biswaas.com/api/doctor/checkToken", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({}),
      });

      const result = await response.json();

      if (result.status && result.data) {
        let tokens = Array.isArray(result.data) ? result.data : [result.data];

        // Filter only ACTIVE tokens (0 or 4) and ONLY from today
        const activeTokens = tokens.filter(token => (token.status === 0 || token.status === 4) && token.isToday);

        if (activeTokens.length > 0) {
          setAllTokens(activeTokens);
          const newIndex = activeTokenIndex >= activeTokens.length ? 0 : activeTokenIndex;
          setActiveTokenIndex(newIndex);
          setTokenData(activeTokens[newIndex]);
          setIsVisible(true);
        } else {
          // Check for treated (1) or skipped (2) tokens to show "Regenerate" message
          const latestInactive = tokens.find(t => t.status === 1 || t.status === 2);
          if (latestInactive) {
            setAllTokens([latestInactive]);
            setActiveTokenIndex(0);
            setTokenData(latestInactive);
            setIsVisible(true);
          } else {
            setIsVisible(false);
            setAllTokens([]);
          }
        }
      } else {
        setIsVisible(false);
      }
    } catch (err) {
      console.error("Compact tracking error:", err);
      setIsVisible(false);
    } finally {
      setLoading(false);
    }
  }, [activeTokenIndex]);

  useEffect(() => {
    fetchTokenTracking();
    const interval = setInterval(fetchTokenTracking, 15000);
    return () => clearInterval(interval);
  }, [fetchTokenTracking]);

  if (loading || !isVisible || allTokens.length === 0) return null;

  const currentToken = allTokens[activeTokenIndex];
  const doctor = currentToken?.doctor || {};

  const isStatusActive = (currentToken?.status === 0 || currentToken?.status === 4) && currentToken?.isToday;
  const showNext = (doctor.status != 2 && currentToken?.currentToken == 1) || currentToken?.currentTokenStatus === 0;

  const handleTrackingClick = () => {
    navigate('/trackii');
  };

  const handleRegenerateClick = (e) => {
    e.stopPropagation();
    if (currentToken?.doctor_id) {
      navigate(`/doctor/${currentToken.doctor_id}`);
    }
  };

  return (
    <div
      className="compact-tracking-bar"
      style={{
        position: 'fixed', top: '90px', left: '50%', transform: 'translateX(-50%)', zIndex: '1020',
        width: 'auto', minWidth: '320px', background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(12px)',
        borderRadius: '50px', border: `1px solid ${isStatusActive ? 'rgba(16, 185, 129, 0.3)' : 'rgba(239, 68, 68, 0.3)'}`, boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
        padding: '6px 18px', display: 'flex', alignItems: 'center', gap: '12px', transition: 'all 0.3s ease',
        cursor: 'pointer'
      }}
      onClick={handleTrackingClick}
    >
      <style dangerouslySetInnerHTML={{
        __html: `
                .pulse-dot-live {
                    width: 7px; height: 7px; background-color: #10b981; border-radius: 50%;
                    animation: pulse-ring 2s infinite; margin-right: 8px;
                }
                .pulse-dot-red {
                    width: 7px; height: 7px; background-color: #ef4444; border-radius: 50%;
                    animation: pulse-ring-red 2s infinite; margin-right: 8px;
                }
                @keyframes pulse-ring {
                    0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7); }
                    70% { box-shadow: 0 0 0 10px rgba(16, 185, 129, 0); }
                    100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
                }
                @keyframes pulse-ring-red {
                    0% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7); }
                    70% { box-shadow: 0 0 0 10px rgba(239, 68, 68, 0); }
                    100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
                }
            `}} />

      <div className="d-flex align-items-center border-end pe-3" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
        <div className={isStatusActive ? "pulse-dot-live" : "pulse-dot-red"}></div>
        <span className={isStatusActive ? "fw-bold text-success" : "fw-bold text-danger"} style={{ fontSize: '10px', letterSpacing: '0.5px' }}>
          {isStatusActive ? "LIVE" : (currentToken.status === 2 ? "SKIPPED" : "ALERTS")}
        </span>
      </div>

      <div className="d-flex align-items-center gap-3">
        {isStatusActive ? (
          <>
            <div className="d-flex flex-column align-items-center">
              <span className="text-muted fw-bold" style={{ fontSize: '8px' }}>MY TOKEN</span>
              <span className="badge bg-success rounded-pill px-2" style={{ fontSize: '12px' }}>#{currentToken.token_no}</span>
            </div>

            <div className="d-flex flex-column align-items-center">
              <span className="text-muted fw-bold" style={{ fontSize: '8px' }}>
                {showNext ? "NEXT" : "SERVING"}
              </span>
              <span className="badge bg-primary rounded-pill px-2" style={{ fontSize: '12px' }}>
                {showNext ? "N/A" : (currentToken.currentToken || "1")}
              </span>
            </div>

            <div className="d-none d-md-flex flex-column border-start ps-3" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
              <div className="fw-bold text-dark text-truncate" style={{ fontSize: '10px', maxWidth: '100px' }}>
                {doctor.name_title || "Dr."} {doctor.fullname}
              </div>
              <div className="text-muted fw-bold" style={{ fontSize: '8px' }}>
                <i className="fa-solid fa-clock me-1"></i>{currentToken.shift_time || "Morning"}
              </div>
            </div>
          </>
        ) : (
          <div className="d-flex flex-column flex-md-row align-items-md-center gap-1 gap-md-2" onClick={handleRegenerateClick}>
            <span className="text-muted fw-bold" style={{ fontSize: '10px' }}>
              {currentToken.status === 2 ? "Token Skipped." : "Consultation finished."}
            </span>
            <span className="text-primary fw-bold text-decoration-underline" style={{ fontSize: '10px' }}>
              Regenerate for Dr. {doctor.fullname}
            </span>
          </div>
        )}
      </div>

      <div className="d-flex align-items-center gap-2 border-start ps-3 ms-1" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
        {allTokens.length > 1 && (
          <div className="d-flex gap-1">
            {allTokens.map((_, index) => (
              <button
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveTokenIndex(index);
                }}
                className={`btn btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center fw-bold ${activeTokenIndex === index ? 'btn-success text-white' : 'btn-light border text-muted'}`}
                style={{ width: '20px', height: '20px', fontSize: '9px' }}
              >
                {index + 1}
              </button>
            ))}
          </div>
        )}
        <button
          className="btn btn-sm p-0 ms-1 opacity-50"
          onClick={(e) => {
            e.stopPropagation();
            setIsVisible(false);
          }}
        >
          <i className="fa-solid fa-circle-xmark" style={{ fontSize: '14px' }}></i>
        </button>
      </div>
    </div>
  );
};

export default CompactTracking;
